module.exports = __webpack_public_path__ + "static/media/HomeIcon.1032689e.svg";